import React from "react"
import {
  Modal,
  Col,
  Row,
  Container,
  Table,
  Button,
} from "reactstrap"
import cplLogo from "../../assets/images/cpl-logo.png"
import CardComponent from "components/Card"
import BarChart from "components/Chart/BarChart"

const InvoiceModal = ({ modal, toggle, invoiceData }) => {

  const labels = ['January', 'February', 'March', 'April', 'May', 'June'];

  const data = {
    labels,
    datasets: [
      {
        label: 'Kilowatt Hours',
        data: [3200, 2500, 3500, 4100, 4300, 4000],
        backgroundColor: '#000',
      },
      {
        label: 'On Peak',
        data: [2600, 2000, 3000, 4000, 3500, 2500],
        backgroundColor: '#3d3d3d',
      },
      {
        label: 'Off Peak',
        data: [1300, 1500, 2500, 3500, 3000, 2200],
        backgroundColor: '#e5e5e5',
      },
    ],
  };

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <CardComponent
          title="Tenant"
          subtitle="INVOICE"
          closeButton={modal}
          toggleCloseButton={toggle}
        >
          <Container style={{ border: "3px solid #ff8b6d" }}>
            <Row className="px-3">
              <Col xs={12}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <div className="logo-lg">
                  <img src={cplLogo} alt="" height="60em" width="auto" />
                </div>
                <h6>29-19 39th Ave.</h6>
                <h6>Long Island City, NY 11101</h6>
              </Col>
            </Row>
            <Row className="px-5">
              <Col xs={12} className="mb-5">

                <div className="d-flex my-3 justify-content-between">
                  <h6>Electricity Bill</h6>
                  <div className="d-flex justify-content-between m-0 p-0">
                    <div className="d-flex flex-column m-1 p-0">
                      <span style={{ backgroundColor: '#f2f2f2', margin: '1px' }}>Invoice Number</span>
                      <span style={{ backgroundColor: '#f2f2f2' }}>EL 323.100-0100-CU</span>
                    </div>
                    <div className="d-flex flex-column m-1 p-0">
                      <span style={{ backgroundColor: '#f2f2f2', margin: '1px' }}>Invoice Date</span>
                      <span style={{ backgroundColor: '#f2f2f2' }}>4/10/2023</span>
                    </div>
                  </div>

                </div>
                <Table borderless responsive size="sm" >
                  <thead style={{ backgroundColor: '#f2f2f2' }}>
                    <tr>
                      <th colspan="1">Period</th>
                      <th colspan="1">From</th>
                      <th colspan="1">to</th>
                      <th colspan="1">No. Days</th>
                      <th colspan="2">READINGS</th>
                      <th colspan="3">CONSUMPTIONS</th>
                      <th colspan="1">DEMAND</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="1">2023/3</td>
                      <td colspan="1">2/18/2023</td>
                      <td colspan="1">3/18/2023</td>
                      <td colspan="1">28</td>
                      <td colspan="1">Previous</td>
                      <td colspan="1">Current</td>
                      <td colspan="1">On Peak</td>
                      <td colspan="1">Off Peak</td>
                      <td colspan="1">Total Usage</td>
                      <td colspan="1">KW</td>
                    </tr>
                    <tr>
                      <td colspan="1"></td>
                      <td style={{ backgroundColor: '#f2f2f2' }} colspan="2">Meter No.</td>
                      <td style={{ backgroundColor: '#f2f2f2' }} colspan="1">Multi.</td>
                    </tr>
                    <tr>
                      <td colspan="1"></td>
                      <td colspan="2">1338TMAJ0339</td>
                      <td colspan="1">0.00</td>
                      <td colspan="1">123,456,789</td>
                      <td colspan="1">123,456,789</td>
                      <td colspan="1">1,149.00</td>
                      <td colspan="1">766.22</td>
                      <td colspan="1">1,915.22</td>
                      <td colspan="1">0.00</td>
                    </tr>
                    <tr>
                      <td colspan="1"></td>
                      <td colspan="2">1338TMAJ0339</td>
                      <td colspan="1">0.00</td>
                      <td colspan="1">123,456,789</td>
                      <td colspan="1">123,456,789</td>
                      <td colspan="1">1,149.00</td>
                      <td colspan="1">766.22</td>
                      <td colspan="1">1,915.22</td>
                      <td colspan="1">0.00</td>
                    </tr>
                    <tr>
                      <td colspan="5"></td>
                      <td colspan="1">Totals</td>
                      <td colspan="1">2,799.00</td>
                      <td colspan="1">1,866.46</td>
                      <td colspan="1">4,665.46</td>
                      <td colspan="1">0.00</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col className="mt-5 d-flex justify-content-between p-3" xs={12} >
                <Table borderless responsive size="sm">
                  <tbody style={{ backgroundColor: '#f2f2f2' }} className="text-start">
                    <tr>
                      <td>Service Class</td>
                      <td> AVG Cost 1</td>
                    </tr>
                    <tr>
                      <td>Service Fee</td>
                      <td>$0.00/per meter</td>
                    </tr>
                    <tr>
                      <td>Admin Fee</td>
                      <td>0.00%</td>
                    </tr>
                    <tr>
                      <td>EL Adjust Factor</td>
                      <td>NA</td>
                    </tr>
                    <tr>
                      <td>Average Cost KWH</td>
                      <td>$0.274482</td>
                    </tr>
                    <tr>
                      <td>Average Cost KW</td>
                      <td>NA</td>
                    </tr>
                    <tr>
                      <td>LEMP Rate</td>
                      <td>0.0000000</td>
                    </tr>
                  </tbody>
                </Table>
                <Table borderless responsive size="sm">
                  <tbody className="text-start">
                    <tr>
                      <td>Sub Total</td>
                      <td>$1,280.58</td>
                    </tr>
                    <tr>
                      <td>Admin Fee</td>
                      <td>$0.00</td>
                    </tr>
                    <tr>
                      <td>Service Fee</td>
                      <td>0.00%</td>
                    </tr>
                    <tr>
                      <td>Sub Total</td>
                      <td>$1,280.58</td>
                    </tr>
                    <tr>
                      <td>Sales Tax</td>
                      <td>$81.64</td>
                    </tr>
                    <tr>
                      <td>Total Due</td>
                      <td>$1,362.22</td>
                    </tr>
                    <tr>
                      <td>LEMP Rate</td>
                      <td>0.0000000</td>
                    </tr>
                  </tbody>
                </Table>

              </Col>
              <Col xs={12} className="border-bottom">
                <div style={{ width: '55%' }}>
                  <BarChart data={data} />
                </div>
              </Col>
              <Col xs={6} className="my-3 text-start">
                <span>Tenant Name and Address:</span>
                <h6 className="p-0 m-0">Comet Technologies(100-0100-CU)</h6>
                <h6 className="p-0 m-0">100 Trap Falls Road Ext.</h6>
                <h6 className="p-0 m-0">Unit 1</h6>
                <h6 className="p-0 m-0">Shelton, CT 06484</h6>
              </Col>
              <Col xs={6} className="my-3 text-start">
                <span>Make Check Payable To:</span>
                <h6 className="p-0 m-0">Comet Technologies(100-0100-CU)</h6>
                <h6 className="p-0 m-0">100 Trap Falls Road Ext.</h6>
                <h6 className="p-0 m-0">Unit 1</h6>
                <h6 className="p-0 m-0">Shelton, CT 06484</h6>
              </Col>
              <Col xs={12} className="text-center">
                <p className="m-0 p-0">If you have any questions about your bill, please call CPL Energy Management Services @ 212-664-7600 ext 2 or email us at</p>
                <p className="m-0 p-0">rb@cplems.com</p>
                <p className="m-0 p-0">To view online bill, login to cplgroupusa.com/login-system/ with access code</p>
                <p className="m-0 p-0">100-0100-CU.100TF</p>
              </Col>
            </Row>
          </Container>
          <Button className="btn border border-none rounded-5 mt-5 fs-2 px-5" style={{ backgroundColor: "#ff8b6d", color: '#fff' }}>DOWNLOAD INVOICE</Button>
        </CardComponent>
      </Modal>
    </>
  )
}

export default InvoiceModal
